export default "struct TextureDisplacementResult {\n\tvec3 position;\n\tvec3 normal;\n};"